// sessionStorage survives reloads for a direct/standalone visit (not
// partitioned there — it's a genuine top-level, first-party context). When
// embedded in another site's iframe it may be partitioned differently, but
// that's fine: the embedded flow never reloads the page, so the in-memory
// copy below is all it needs for the lifetime of that page.
let token: string | null = (() => {
  try {
    return sessionStorage.getItem('devops-api-token')
  } catch {
    return null
  }
})()

export function getToken(): string | null {
  return token
}

export function setToken(value: string | null): void {
  token = value
  try {
    if (value) sessionStorage.setItem('devops-api-token', value)
    else sessionStorage.removeItem('devops-api-token')
  } catch {
    /* storage unavailable — in-memory copy still works for this page load */
  }
}
